module.exports = __webpack_public_path__ + "img/16581280_S.984df518.png";